import Axios from "axios";

export const PatchUpdateUser = async (name, middle_name, last_name, email, phone_number, phone_number_home, phone_number_office, fk_genre, fk_status, fk_job_position, fk_subsidiary, fk_privilege, fk_sub_privilage, id, idPerson) => {
    try {
        const res = await Axios.patch(process.env.REACT_APP_API_URL + "updateUser/" + id + '/' + idPerson, {
            name,
            middle_name,
            last_name,
            email,
            phone_number,
            phone_number_home,
            phone_number_office,
            fk_genre,
            fk_status,
            fk_job_position,
            fk_subsidiary,
            fk_privilege,
            fk_sub_privilage,
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}
export const PatchRegisterSignaturesToEmployee = async (id_person, signatureURL) => {
    const res = await Axios.patch(process.env.REACT_APP_API_URL + `patchRegisterSignaturesToEmployee/`,
        {
            id_person, signatureURL
        },
        {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
    return res.data
}
